<!-- THIS TEMPLATE ALLOWS MANY DIFFERENT NG-CONTENTs TO BE RENDERED -->
<ng-template #contentTpl><ng-content></ng-content></ng-template>

<ng-template #actionButtons let-child="child">
	<div class="col-2 no-padding-right text-align-right">
		<icon
			*ngIf="BlendPortfolioUtil.isUserPortfolio(child) || BlendPortfolioUtil.isAPMSleeve(child)"
			class="btn header-anchor"
			type="pencil"
			(click)="emitOpenChildView(child)"
		></icon>
		<icon *ngIf="BlendPortfolioUtil.isModel(child)" class="btn header-anchor" type="eye" (click)="emitOpenChildView(child)"></icon>
	</div>
</ng-template>

<!-- ACCORDION CODE -->
<!--
	To use this, do
	<ac-blending-accordion>
	<ac-blending-accordion-panel
			specify input variables...
		>
			Top level row content after the chevron
		</ac-blending-accordion-panel>
	</ac-blending-accordion>
-->
<ng-container>
	<div class="row panel-header">
		<div class="col-{{ panelDepth }}"></div>
		<div class="col-1 icon-container">
			<a *ngIf="!isChildInvalid" class="header-anchor" [ngClass]="{ disabled: isCircularPortfolio }" (click)="togglePanel($event)">
				<icon
					type="chevron-up"
					class="icon-expandable"
					[ngClass]="{
						'in-dialog': inDialog,
						'expandable-model-portfolio': inDialog && BlendPortfolioUtil.isModel(portfolioChild),
						collapsed: isCollapsed,
						'level-zero-portfolio': !isCollapsed && panelDepth === 0,
						'level-one-portfolio': panelDepth === 1,
						'level-two-portfolio': panelDepth === 2
					}"
				></icon>
			</a>
		</div>
		<ng-container *ngTemplateOutlet="contentTpl"></ng-container>

		<ng-container *ngIf="portfolioChild && isEditable">
			<ng-container *ngTemplateOutlet="actionButtons; context: { child: portfolioChild }"></ng-container>
			<div class="col-1 text-align-right">
				<icon *ngIf="panelDepth < 1" class="btn" type="times" (click)="removeChild(portfolioChild)"></icon>
			</div>
		</ng-container>
	</div>

	<section [@slideInOut] *ngIf="!isCollapsed" class="panel-content">
		<ng-container *ngIf="portfolioChild; else assetClassView">
			<ng-container *ngFor="let subChild of portChildrenMap[portfolioChild.identifier].childrenRef; trackBy: trackByIdentifier">
				<!-- RECURSION -->
				<ac-blending-accordion
					class="col-24 panel-content-row child-accordion margin-top-20"
					*ngIf="
						(isEditable && subChild.type === PORTFOLIO && !inDialog && !portChildrenMap[subChild.identifier].isFlat) ||
							(!isEditable && subChild.type === PORTFOLIO_POSITION) ||
							(!isEditable && BlendPortfolioUtil.isModel(subChild) && inDialog);
						else notAccordion
					"
				>
					<ac-blending-accordion-panel
						[panelDepth]="panelDepth + 1"
						[portfolioChild]="subChild"
						[inDialog]="inDialog"
						[portChildrenMap]="portChildrenMap"
						[isWeightActive]="isWeightActive"
						[isEditable]="isEditable"
						[parentProjectedTotalAmount]="childrenAmountBreakdown[subChild.identifier]"
						(removeChildClicked)="removeChild($event)"
						(openChildViewClicked)="emitOpenChildViewFromChildAccordion($event)"
					>
						<div
							[ngClass]="{
								'col-17': inDialog && panelDepth === 1,
								'col-16': !inDialog && panelDepth === 0,
								'col-15': !inDialog && panelDepth === 1,
								'col-14': !inDialog && panelDepth === 2
							}"
						>
							<div class="text-16-bold">
								{{ subChild.description }}
								<div class="text-12 color-gray-dark" *ngIf="BlendPortfolioUtil.isModel(subChild)">{{ MODEL_PORTFOLIO_TEXT }}</div>
							</div>
						</div>
						<div
							class="text-16-bold text-align-right"
							[ngClass]="{
								'col-2': inDialog && panelDepth === 1,
								'col-3': !inDialog && panelDepth === 0,
								'col-4': (inDialog && panelDepth === 2) || (!inDialog && panelDepth === 1),
								'col-5': inDialog && panelDepth === 3
							}"
						>
							<span *ngIf="isWeightActive; else notWeightActive">{{ subChild.weight | number : '.0-2' }}</span
							><span *ngIf="!isEditable">%</span>
							<ng-template #notWeightActive>
								{{ childrenAmountBreakdown[subChild.identifier] | number : '.0-2' }}
							</ng-template>
						</div>
					</ac-blending-accordion-panel>
				</ac-blending-accordion>

				<ng-template #notAccordion>
					<div class="row panel-content-row new-portfolio-row non-accordion-row">
						<div
							[ngClass]="{
								'col-1': !inDialog && panelDepth === 0,
								'col-2': inDialog && panelDepth === 1,
								'col-3': !inDialog && panelDepth === 1,
								'col-4': (!inDialog && panelDepth === 2) || (inDialog && panelDepth === 2)
							}"
						></div>

						<div
							class="col-1"
							[ngClass]="{
								'in-dialog': inDialog,
								'level-one-holding': (!inDialog && panelDepth === 0) || (inDialog && panelDepth === 1),
								'level-two-holding': (!inDialog && panelDepth === 1) || (inDialog && panelDepth === 2),
								'level-three-holding': (!inDialog && panelDepth === 2) || (inDialog && panelDepth === 3)
							}"
						></div>

						<ng-container *ngIf="subChild.ticker; else portfolio">
							<div [ngClass]="{ 'col-3': enableBlending, 'col-2': !enableBlending }">
								{{ subChild.ticker }}
							</div>
							<div
								[ngClass]="{
									'col-14': enableBlending && ((!inDialog && panelDepth === 0) || (inDialog && panelDepth === 1)),
									'col-15': !enableBlending && ((!inDialog && panelDepth === 0) || (inDialog && panelDepth === 1)),
									'col-12': (!inDialog && panelDepth === 1) || (inDialog && panelDepth === 2)
								}"
							>
								{{ subChild.description }}
								<ng-container
									*ngIf="enableBlending && !BlendPortfolioUtil.isUserPortfolio(subChild)"
									[ngTemplateOutlet]="securityInfo"
									[ngTemplateOutletContext]="{ security: subChild }"
								></ng-container>
							</div>
						</ng-container>

						<ng-template #portfolio>
							<div
								[ngClass]="{
									'col-17': (!inDialog && panelDepth === 0) || (inDialog && panelDepth === 1),
									'col-14': !inDialog && panelDepth === 1
								}"
							>
								<div>
									{{ subChild.description }}
									<ng-container
										*ngIf="enableBlending && !BlendPortfolioUtil.isUserPortfolio(subChild)"
										[ngTemplateOutlet]="securityInfo"
										[ngTemplateOutletContext]="{ security: subChild }"
									></ng-container>
								</div>
								<div class="text-12 color-gray-dark" *ngIf="BlendPortfolioUtil.isModel(subChild)">{{ MODEL_PORTFOLIO_TEXT }}</div>
							</div>
						</ng-template>

						<div
							class="text-16 text-align-right"
							[ngClass]="{
								'in-dialog': inDialog,
								'col-2': (!inDialog && panelDepth === 0) || (inDialog && panelDepth === 1),
								'col-3': (!inDialog && panelDepth === 1) || (inDialog && panelDepth === 2),
								'col-4': !inDialog && panelDepth === 2
							}"
						>
							<span *ngIf="isWeightActive; else notWeightActive">{{ subChild.weight | number : '.0-2' }}</span
							><span *ngIf="!isEditable">%</span>
							<ng-template #notWeightActive>
								<span>{{ childrenAmountBreakdown[subChild.identifier] | number : '.0-2' }}</span>
							</ng-template>
						</div>

						<ng-container *ngIf="isEditable">
							<ng-container *ngTemplateOutlet="actionButtons; context: { child: subChild }"></ng-container>
						</ng-container>
					</div>
				</ng-template>
			</ng-container>
		</ng-container>

		<!-- Holdings/Asset Class View TEMPLATE -->
		<ng-template #assetClassView>
			<div class="row no-margin no-padding text-14-bold padding-top-10">
				<div class="col-2"></div>
				Contributing Portfolios
			</div>
			<ng-container *ngFor="let portfolio of holdingDetailsChild.contributingPortfolios">
				<div class="row new-portfolio-row panel-content-row margin-left-10">
					<div class="col-2"></div>
					<div class="col-19">{{ portfolio.name }}</div>
					<div
						*ngIf="isWeightActive; else notWeightActive"
						class="text-align-right"
						[ngClass]="{
							'in-dialog': inDialog,
							'col-3': !inDialog && panelDepth === 0,
							'col-2': (!inDialog && panelDepth === 1) || (!inDialog && panelDepth === 2)
						}"
					>
						{{ portfolio.weight | number : '.2' }}%
					</div>
					<ng-template #notWeightActive>
						<div class="col-3 text-align-right">
							<span> {{ portfolio.value | number : '.0-2' }} </span>
						</div>
					</ng-template>
				</div>
			</ng-container>
		</ng-template>
	</section>
</ng-container>

<ng-template #securityInfo let-security="security">
	<div class="text-14 asset-details">
		Market: <ng-container *ngIf="security.market; else blankField">{{ security.market }}</ng-container
		>, Ccy: <ng-container *ngIf="security.currency; else blankField">{{ security.currency }}</ng-container
		>, ISIN: <ng-container *ngIf="security.isin; else blankField">{{ security.isin }}</ng-container
		>, Ticker: <ng-container *ngIf="security.ticker; else blankField">{{ security.ticker }}</ng-container>
	</div>
</ng-template>

<ng-template #blankField>-</ng-template>
